<template>
  <div :class="['island-soil']">
    <h4 v-if="header" class="island-soil__header">
      {{ header }}
    </h4>

    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
.island-soil {
  padding: measure(quarter);
  border: 1px solid color(border-gray);
  background-color: color(background-white);
}

.island-soil--no-padding {
  padding: 0;
}

.island-soil__header {
  @include h2-semi-bold;
  margin-top: 0;
  margin-bottom: measure(half);
}
</style>
